/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Inbox_Na_Detail_LeftInputs */

const en_inbox_na_detail_left = /** @type {(inputs: Inbox_Na_Detail_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} steps left`)
};

const id_inbox_na_detail_left = /** @type {(inputs: Inbox_Na_Detail_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} langkah tersisa`)
};

/**
* | output |
* | --- |
* | "{n} steps left" |
*
* @param {Inbox_Na_Detail_LeftInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_detail_left = /** @type {((inputs: Inbox_Na_Detail_LeftInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Detail_LeftInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_detail_left(inputs)
	return en_inbox_na_detail_left(inputs)
});